export default __webpack_public_path__ + "static/NGSwv5HMAFg6IuGlBNMjxLsK8ahuQ2e8Smg-c9f2d75d3a7606a130739de27367f9a9.woff2";